import clsx from "clsx";
import Styles from "./index.module.scss";
import { formatNumber } from "../../../Utils";
import { MdHistory } from "react-icons/md";
import { clientTransaction } from "../../../Api/SubUrl";
export const ClientHistoryModalTable = ({ title, columns, data, total }) => {
  return (
    <div className={clsx(Styles.histories)}>
      <div className={clsx(Styles.header)}>
        <p className={clsx(Styles.title)}>
          <MdHistory className={Styles.icon} />
          {title}
        </p>
        {total && (
          <p className={clsx(Styles.total)}>
            Tổng thưởng: {formatNumber(total)} KNB Khóa
          </p>
        )}
      </div>
      <div className={clsx(Styles.tableContainer)}>
        <table>
          <thead>
            <tr>
            {columns.map((column, index) => (
              <th
                key={index}
                className={column.align === "center" ? Styles.center : undefined}
              >
                {column.header}
              </th>
            ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns.map((column, colIndex) => (
                  <td
                    key={colIndex}
                    className={column.align === "center" ? Styles.center : undefined}
                  >
                    {column.render ? column.render(row) : row[column.key] ?? ""}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className={clsx(Styles.footer)}>
        {/* <a href={clientTransaction}>Xem thêm {">>"}</a> */}
        <a href="/" onClick={(e) => e.preventDefault()}>Xem thêm {">>"}</a>
      </div>
    </div>
  );
};
